import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
import { slideUpVariants } from '../../constants/animations';
import styles from './NewPhotosBanner.module.css';

interface NewPhotosBannerProps {
  count: number;
  onClick: () => void;
}

export function NewPhotosBanner({ count, onClick }: NewPhotosBannerProps) {
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.button
          onClick={onClick}
          className={styles.banner}
          variants={slideUpVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          whileHover={{
            y: -3,
            boxShadow: [
              '0 12px 36px rgba(34,197,94,0.32)',
              '0 4px 10px rgba(0,0,0,0.18)',
              'inset 0 1px 0 rgba(255,255,255,0.22)',
              'inset 0 -1px 0 rgba(0,0,0,0.06)',
            ].join(', '),
          }}
          whileTap={{ scale: 0.985, y: 0 }}
          transition={{ type: 'spring', stiffness: 400, damping: 28 }}
        >
          {/* Shimmer sweep */}
          <motion.span
            className={styles.shimmer}
            animate={{ x: ['-100%', '200%'] }}
            transition={{ repeat: Infinity, duration: 2.8, ease: 'linear', repeatDelay: 1.5 }}
          />

          {/* Count pill */}
          <motion.span
            className={styles.pill}
            key={count}
            initial={{ scale: 1.35, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 500, damping: 22 }}
          >
            +{count}
          </motion.span>

          {/* Label */}
          <span className={styles.label}>
            new photo{count !== 1 ? 's' : ''} available — tap to refresh
          </span>

          {/* Arrow */}
          <motion.span
            className={styles.arrow}
            animate={{ rotate: [0, 360] }}
            transition={{ repeat: Infinity, duration: 3, ease: 'linear', repeatDelay: 2 }}
          >
            <RefreshCw className={styles['icon-sm']} />
          </motion.span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
